import { OrderPaymentMethod } from "../constants";

export const getOrderPaymentMethodLabel = (
  paymentMethod: OrderPaymentMethod
) => {
  switch (paymentMethod) {
    case OrderPaymentMethod.CashOnDelivery:
      return "Cash";

    case OrderPaymentMethod.MobileMoney:
      return "Mobile Money";

    case OrderPaymentMethod.Card:
      return "Card";

    default:
      return "";
  }
};
